import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import {
  CsobFormMetaDataDto,
  FormBaseType,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_CSOB } from "../domain";
import { ACTION_GET_CSOB_FORMS_METADATA } from "../GetCsobFormsMetadata";

import { csobHubApi } from "@api/services";
import { ACTION_GET_AVAILIBLE_FORMS, DOMAIN_FORMS, roleGuard } from "@api";

export const ACTION_CREATE_CSOB_FORM = "CREATE_CSOB_FORM";

const allowedRoles = [UserRole.Owner];

type CreateCsobFormRequest = CsobFormMetaDataDto;

const createCsobForm = async (
  req: CreateCsobFormRequest,
): Promise<CsobFormMetaDataDto> => {
  const response = await csobHubApi.csobHubControllerCreateFormMetaData(req);

  return response.data as unknown as CsobFormMetaDataDto;
};

export const useCreateCsobForm = (
  user: UserProfileDto | null,
): {
  createCsobForm: UseMutateFunction<
    CsobFormMetaDataDto,
    Error,
    CreateCsobFormRequest,
    unknown
  >;
  createCsobFormEnabled: boolean;
  isSuccessCreateCsobForm: boolean;
  isPendingCreateCsobForm: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending } = useMutation<
    CsobFormMetaDataDto,
    Error,
    CreateCsobFormRequest,
    unknown
  >({
    mutationKey: [DOMAIN_CSOB, ACTION_CREATE_CSOB_FORM],
    mutationFn: enabled ? createCsobForm : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          DOMAIN_FORMS,
          ACTION_GET_AVAILIBLE_FORMS,
          [
            FormBaseType.CsobClient,
            FormBaseType.CsobCommercialRealityAsset,
            FormBaseType.CsobEnergyAsset,
          ],
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_CSOB, ACTION_GET_CSOB_FORMS_METADATA],
      });
    },
  });

  return {
    createCsobForm: mutate,
    createCsobFormEnabled: enabled,
    isSuccessCreateCsobForm: isSuccess,
    isPendingCreateCsobForm: isPending,
  };
};
